import { LEGAL_AFFILIATE_HEADING } from './0-heading.md';
import { LEGAL_AFFILIATE_TERMS_INTRODUCTION } from './1-introduction.md';
import { LEGAL_AFFILIATE_REGISTRATION } from './3-affiliate-registration.md';
import { LEGAL_AFFILIATE_OBLIGATIONS } from './4-affiliate-obligations.md';
import { LEGAL_COMMISSIONS_AND_PAYOUTS } from './5-commissions-payouts.md';
import { LEGAL_NEWS_COMMUNICATION_AND_UPDATES } from './6-news-communication-updates.md';
import { LEGAL_AFFILIATE_LIMITATION } from './8-limitation-of-liability.md';
import { LEGAL_AFFILIATE_TERMINATION } from './11-termination.md';
import { LEGAL_CONTRACTUAL_INFORMATION } from '../terms-of-use/2-contractual-information.md';
import { LEGAL_PRIVACY_STATEMENT } from '../terms-of-use/13-privacy-statement.md';
import { LEGAL_GOVERNING_LAW } from '../terms-of-use/16-governing-law.md';
import { LEGAL_CHANGES_TO_TERMS } from '../terms-of-use/17-changes-to-terms.md';
import { LEGAL_SEVERABILITY } from '../terms-of-use/19-severability.md';
import { LEGAL_ASSIGNMENT } from '../terms-of-use/20-assignment.md';


/**------------------------------------------------------
 * Imprint Template
 */
export const LEGAL_AFFILIATE_TERMS_TEMPLATE_EN: string = `
	<!-- let sectionIndex = 0; subSectionIndex = 0; -->
	${LEGAL_AFFILIATE_HEADING}
	${LEGAL_AFFILIATE_TERMS_INTRODUCTION}
	---
	${LEGAL_CONTRACTUAL_INFORMATION}
	---
	${LEGAL_AFFILIATE_REGISTRATION}
	---
	${LEGAL_AFFILIATE_OBLIGATIONS}
	---
	${LEGAL_COMMISSIONS_AND_PAYOUTS}
	---
	${LEGAL_NEWS_COMMUNICATION_AND_UPDATES}
	---
	${LEGAL_PRIVACY_STATEMENT}
	---
	${LEGAL_AFFILIATE_LIMITATION}
	---
	${LEGAL_GOVERNING_LAW}
	---
	${LEGAL_CHANGES_TO_TERMS}
	---
	${LEGAL_AFFILIATE_TERMINATION}
	---
	${LEGAL_SEVERABILITY}
	---
	${LEGAL_ASSIGNMENT}
`;
